<template>
  <div>
    <v-flex elevation-1 mx-4 mb-3 mt-2 class="white">
      <v-container grid-list-xs fluid>
        <!-- <h3 class="mb-3" >Packing Specifications</h3> -->
        <v-layout row wrap pt-4>
          <v-textarea
            :disabled="!c_user.edit"
            rows="1"
            label="Packing Specifications"
            @input="artwork.transport_history = $event"
            :value="artwork.transport_history"
            auto-grow
            class="mr-4"
          ></v-textarea>
          <!-- <text-editor @input="artwork.content=$event" :value="artwork.content"></text-editor> -->
          <!-- <v-textarea v-model="edited_text.content" auto-grow  class="flex xs12 ml-2" name="Text" label="Text"></v-textarea> -->
          <!-- <v-flex class="mt-1 mb-0"> -->
          <v-btn
            class="mt-3 right"
            small
            dark
            @click="saveField"
            v-if="c_user.edit"
            >save</v-btn
          >
          <!-- <v-btn @click="edit_dialog=!edit_dialog">cancel</v-btn> -->
          <!-- </v-flex> -->
        </v-layout>
      </v-container>
      <!-- <v-btn icon class="left mr-0 pr-0" xs12 @click="dropzone.processQueue()"><v-icon>send</v-icon></v-btn> -->
    </v-flex>

    <v-toolbar flat class="editBG pl-2">
      <v-menu
        offset-y
        :close-on-content-click="false"
        class="text-xs-left ml-5 my-0 py-0 align-left left"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            small
            icon
            color="black"
            dark
            v-on="on"
            class="text-xs-right mx-0 mt-1 my-0 py-0"
          >
            <v-icon small>sort</v-icon>
          </v-btn>
        </template>
        <v-list value="last_name">
          <v-list-tile
            v-for="(item, index) in [
              'colli',
              'packing',
              'height',
              'width',
              'depth',
              'weight',
              'contents',
              'visa_status'
            ]"
            :key="index"
            @click="setSorting(item)"
          >
            <v-list-tile-avatar v-if="item == sorting">
              <v-icon v-if="p.descending">mdi-sort-ascending</v-icon>
              <v-icon v-else>mdi-sort-descending</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-avatar v-else>
              <v-icon></v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>{{ item }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-toolbar-title class="elevation-0 px-0 mx-0 left">
        <span class="left mx-0 px-0">Packings</span>
      </v-toolbar-title>
      <!-- <v-divider class="mx-2" inset vertical></v-divider> -->
      <v-spacer></v-spacer>
      <excel-packings
        :data="artwork"
        small="small"
        name="Packings"
        fileName="packings"
      ></excel-packings>
      <!-- CHANGE SELECTED PACKINGS -->
      <!-- <v-dialog v-model="dialog2" max-width="600px">
        <v-btn :disabled="this.selected.length==0" slot="activator" color="primary" dark class="mb-2">Change Selected Packings</v-btn>
        <v-card>
          <v-card-title>
            <span class="headline pl-4 pt-4">Change Selected Packings</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs6>
                  <v-text-field v-model="updated_packing.height"  class="flex pl-2" suffix=" cm" name="height"  label="Height"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="updated_packing.width"   class="flex pl-2" suffix=" cm" name="width"   label="Width"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="updated_packing.length"   class="flex pl-2" suffix=" cm" name="length"   label="Length"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="updated_packing.weigth"   class="flex pl-2" suffix=" cm" name="weigth"   label="Weigth"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea rows=1 v-model="updated_packing.contents" class="flex xs12 ml-2" auto-grow name="contents" label="Contents"></v-textarea>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-radio-group v-model="updated_packing.visa_status">
                    <v-radio v-for="vs in constants.VISA_STATUSES" :key="vs.id" :value="vs.id" :label="vs.name" color="black"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="updated_packing.artwork_location_id"
                    :items="this.selection_items"
                    label="Location" item-text="name" item-value="id" class="xs12 ml-2" 
                    >
                  </v-autocomplete>                  
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions class="pr-5 pb-4">
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="dialog2=false">Cancel</v-btn>
            <v-btn color="green darken-1" flat @click.native="update_multiple">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>-->

      <!-- ADD PACKING -->
      <v-btn
        @click="newItem"
        color="black"
        dark
        small
        class="mb-2"
        v-if="c_user.edit"
        >New Packing</v-btn
      >
      <v-dialog v-model="dialog" max-width="600px" persistent>
        <v-card class="elevation-0">
          <v-card-title>
            <span class="headline pl-4 pt-3 pb-0" v-if="editing">Edit Packing</span>
            <span class="headline pl-4 pt-3 pb-0" v-else>Add Packing</span>
          </v-card-title>
          <v-card-text class="pt-0">
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="packing.colli"
                    class="flex xs12 "
                    name="colli"
                    label="Colli"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="packing.packing"
                    class="flex xs12"
                    name="packing"
                    label="Packing"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="packing.height"
                    class="flex"
                    suffix=" cm"
                    name="height"
                    label="Height"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="packing.width"
                    class="flex pl-2"
                    suffix=" cm"
                    name="width"
                    label="Width"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="packing.lenght"
                    class="flex"
                    suffix=" cm"
                    name="lenght"
                    label="Length"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="packing.weight"
                    class="flex pl-2"
                    suffix=" kg"
                    name="weight"
                    label="Weigth"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    rows="1"
                    v-model="packing.contents"
                    class="flex xs12 "
                    auto-grow
                    name="contents"
                    label="Contents"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 pl-3>
                  <v-radio-group v-model="packing.visa_status" row>
                    <v-radio
                      class="pr-3"
                      color="black"
                      v-for="vs in constants.VISA_STATUSES"
                      :key="vs.id"
                      :value="vs.id"
                      :label="vs.name"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 v-if="!editing">
                  <v-autocomplete
                    clearable
                    v-model="packing.artwork_location_id"
                    :items="this.selection_items"
                    :label="`Select Location ${this.artwork.artwork_location_id == this.packing.artwork_location_id ? ' - taken from main Artwork' : '(Artwork is at: ' + get_location_name(this.artwork.artwork_location_id) + ')'}`"
                    item-text="name"
                    item-value="id"
                    class="xs12 mt-3"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 v-else class="mt-3 pa-3 grey lighten-4">
                  Current location:
                  <b>{{ get_location_name(packing.artwork_location_id) }}</b>.
                  To change it, use the artwork location movement workflow. Packing details cannot move a packing.
                </v-flex>
                <v-flex xs6>
                  <v-menu
                    v-model="menu_storage_in"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="packing.storage_in"
                      label="Storage in"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      v-model="packing.storage_in"
                      @input="menu_storage_in = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6>
                  <v-menu
                    v-model="menu_storage_out"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="packing.storage_out"
                      label="Storage out"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      v-model="packing.storage_out"
                      @input="menu_storage_out = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions class="mr-3 pr-4 pb-5">
            <v-spacer></v-spacer>
            <v-btn small flat @click.native="close">Cancel</v-btn>
            <v-btn small dark @click.native="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteDialog" max-width="400px">
        <v-card>
          <v-card-title class="headline"
            >Are you sure you want to delete this Packing?</v-card-title
          >
          <v-card-text>This Packing will be deleted.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat="flat" @click="cancelDelete">No</v-btn>
            <v-btn color="red darken-1" flat="flat" @click="deleteItem"
              >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- <v-dialog v-model="editDialog" max-width="400px">
        <v-card
          v-if="showDialog"
          class="mb-3 mx-3 pt-0 mt-3 elevation-2"
          style="background-color:#fff;"
        >
          <v-card-title class="px-3 pb-0 mb-0 pt-1">
            <span class="headline pt-2 pb-0 mb-0 pl-2" v-html="!editing ? 'New Cost' : 'Editing Cost'"></span>
          </v-card-title>
          <v-card-text class="mx-0 px-0 my-2 py-0">
            <v-container grid-list-xs pb-0 pt-0>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="packing.colli"
                    class="flex xs12 ml-2"
                    name="colli"
                    label="Colli"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="packing.packing"
                    class="flex xs12 ml-2"
                    name="packing"
                    label="Packing"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="packing.height"
                    class="flex pl-2"
                    suffix=" cm"
                    name="height"
                    label="Height"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="packing.width"
                    class="flex pl-2"
                    suffix=" cm"
                    name="width"
                    label="Width"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="packing.lenght"
                    class="flex pl-2"
                    suffix=" cm"
                    name="lenght"
                    label="Length"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="packing.weight"
                    class="flex pl-2"
                    suffix=" kg"
                    name="weight"
                    label="Weigth"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    rows="1"
                    v-model="packing.contents"
                    class="flex xs12 ml-2"
                    auto-grow
                    name="contents"
                    label="Contents"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="packing.visa_status" row>
                    <v-radio class="pr-3"
                      color="black"
                      v-for="vs in constants.VISA_STATUSES"
                      :key="vs.id"
                      :value="vs.id"
                      :label="vs.name"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="packing.artwork_location_id"
                    :items="this.selection_items"
                    label="Location"
                    item-text="name"
                    item-value="id"
                    class="xs12 ml-2"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-menu
                    v-model="menu_storage_in"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="packing.storage_in"
                      label="Storage in"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="packing.storage_in" @input="menu_storage_in = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6>
                  <v-menu
                    v-model="menu_storage_out"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="packing.storage_out"
                      label="Storage out"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="packing.storage_out" @input="menu_storage_out = false"></v-date-picker>
                  </v-menu>
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions class="pr-4 pb-4">
            <v-spacer></v-spacer>
            <v-btn small class="mr-3" outline @click.native="showDialog=false">Cancel</v-btn>
            <v-btn small dark @click.native="save">
              <span v-if="!editing">Add </span>
              <span v-if="editing">Save </span> cost
            </v-btn>
          </v-card-actions>
        </v-card>
        </v-dialog> -->
    </v-toolbar>

    <v-data-table
      :headers="headers"
      hide-headers
      :pagination.sync="p"
      :items="artwork.artwork_packings"
      item-key="id"
      hide-actions
      class="elevation-1 mx-4"
      v-model="selected"
    >
      <template slot="items" slot-scope="props">
        <tr class="py-0 my-0">
          <td colspan="2">
            <span class="subheadline pl-0">
              <b>{{ props.item.colli }} / {{ props.item.packing }}</b>
              <i v-if="props.item.artwork_location_id"><br>{{ get_location_name(props.item.artwork_location_id) }}</i>
            </span>
          </td>
          <td>
            <span class="subheadline pl-0">
              {{ props.item.contents }}
            </span>
          </td>
          <td class="px-0 text-xs-center">
            <span class="subheadline pl-0">
              {{ get_visa_status(props.item.visa_status) }}
            </span>
          </td>
          <td class="px-0 text-xs-center">
            <span class="subheadline">
              {{ props.item.height }} x {{ props.item.width }} x
              {{ props.item.lenght }} cm
            </span>
          </td>
          <td class="px-0 text-xs-center">
            <span class="subheadline pl-0" v-if="props.item.weight">
              {{ props.item.weight }} kg
            </span>
          </td>
          <td class="px-2 text-xs-right">
            <v-btn flat icon small class="pa-0 ma-0" v-if="c_user.edit">
              <v-icon small pa-0 ma-0 @click="duplicateItem(props.item)"
                >file_copy</v-icon
              >
            </v-btn>
            <v-btn flat icon small class="pa-0 ma-0" v-if="c_user.edit">
              <v-icon small class @click="editItem(props.item)">edit</v-icon>
            </v-btn>
            <v-btn
              flat
              icon
              small
              class="pa-0 ma-0"
              v-if="c_user.delete_rights"
            >
              <v-icon small @click="showDeleteDialog(props.item)"
                >delete</v-icon
              >
            </v-btn>
          </td>
        </tr>
      </template>
      <template slot="no-data">
        <center>No data available.</center>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ExcelPackings from './ExcelPackings'
import constants from '@/data/constants'
import axios from '@/utils/apiClient'
import { serverBus } from '../../main'

function dynamicSort(property) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function(a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}
export default {
  props: ['artwork'],
  data: () => ({
    sorting: 'colli',
    editing: false,
    constants: constants,
    selected: [],
    menu_storage_out: false,
    menu_storage_in: false,
    dialog: false,
    editDialog: false,
    deleteDialog: false,
    itemToDelete: null,
    dialog2: false,
    p: {
      sortBy: 'colli',
      rowsPerPage: -1
    },
    headers: [
      { text: 'Colli', align: 'left', sortable: true, value: 'colli' },
      { text: 'Packing', align: 'left', value: 'packing', sortable: true },
      {
        text: 'Location',
        align: 'center',
        value: 'artwork_location_id',
        sortable: true
      },
      { text: 'Contents', align: 'left', value: 'contents', sortable: true },
      {
        text: 'Visa Status',
        align: 'center',
        value: 'visa_status',
        sortable: true
      },
      {
        text: 'H x W x L',
        align: 'center',
        value: 'height',
        sortable: true
      },
      { text: 'Weight (kg)', align: 'center', value: 'weight', sortable: true },
      { text: '', align: 'right', sortable: false }
    ],
    editedIndex: -1,
    show: false,
    showUpload: false,
    packing: {
      packing: '',
      height: '',
      lenght: '',
      width: '',
      weight: '',
      contents: '',
      created_by: '',
      colli: '',
      visa_status: '',
      artwork_id: '',
      location_id: '',
      artwork_location_id: ''
    },
    updated_packing: {
      packing: '',
      height: '',
      length: '',
      width: '',
      weigth: '',
      contents: '',
      created_by: '',
      colli: '',
      // note: '',
      visa_status: '',
      artwork_id: '',
      location_id: '',
      artwork_location_id: ''
    }
  }),
  computed: {
    all_packings() {
      return this.$store.state.packings
    },
    selection_items() {
      var artworkLocations = Object.assign(
        [],
        this.$store.getters.enabled_locations
      )
      return artworkLocations.sort(dynamicSort('name'))
    }
  },
  methods: {
    setSorting(s) {
      // console.log('receive')
      // console.log(s)
      this.sorting = s
      this.p.sortBy = s
      this.p.descending = !this.p.descending
    },
    newItem() {
      this.dialog = true
      this.packing = {
        packing: '',
        height: '',
        lenght: '',
        width: '',
        weight: '',
        contents: '',
        colli: '',
        created_by: '',
        location_id: '',
        visa_status: '',
        artwork_id: '',
        artwork_location_id: this.artwork.artwork_location_id
      }
    },
    editItem(i) {
      this.packing = { ...i }
      this.saving = false
      this.editing = true
      this.dialog = true
    },
    packingUpdateAttributes() {
      const editableFields = [
        'colli',
        'packing',
        'height',
        'width',
        'lenght',
        'weight',
        'contents',
        'note',
        'visa_status',
        'storage_in',
        'storage_out'
      ]

      return editableFields.reduce((attributes, field) => {
        attributes[field] = this.packing[field]
        return attributes
      }, {})
    },
    // saveOrEdit (){
    //     this.progress = true
    //     var value_to_save = this.field_value
    //     if (this.field_type == 'toggle'){
    //       value_to_save = this.toggle
    //     }
    //     if (saveOK) {
    //       // console.log('saveOK')
    //       this.saveField(value_to_save)
    //     } else {
    //       this.cannotSave = true
    //         setTimeout(() => {
    //           this.cannotSave = false
    //         }, 4000);
    //     }
    //   }
    // },
    saveField() {
      this.$emit('showSnackbar', 'Saving Packing Specification.', 'black')
      setTimeout(() => {
        let url = `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`
        axios
          .put(url, {
            field_name: 'transport_history',
            field_value: this.artwork.transport_history
          })
          .then(response => {
            this.progress = false
            this.$emit('showSnackbar', 'Packing Specification saved.', 'green')
          })
          .catch(error => {
            // console.log(error)
          })
      }, 1000)
    },
    close() {
      this.dialog = false
      this.editing = false
      this.resetPacking()
    },
    // initialize () {},
    showDeleteDialog(p) {
      this.itemToDelete = p
      this.deleteDialog = true
    },
    deleteItem() {
      const index = this.artwork.artwork_packings.indexOf(this.itemToDelete)
      var i = this.artwork.artwork_packings.indexOf(this.itemToDelete)
      if (i != -1) {
        this.artwork.artwork_packings.splice(i, 1)
      }
      // confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      this.$store.dispatch('deletePacking', this.itemToDelete)
      this.itemToDelete = null
      this.deleteDialog = false
    },
    cancelDelete() {
      this.deleteDialog = false
      this.itemToDelete = null
    },
    // delete_packing () {},
    duplicateItem(p) {
      // console.log(p)
      var packing = Object.assign({}, p)
      delete packing.id
      // console.log(this.packing)
      packing.artwork_id = this.artwork.id
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = []
      }
      // this.packing.reject { |k,v| k == :id }
      axios
        .post(`${this.$globals.apiserver}/artwork_packings.json`, {
          artwork_packing: packing
        })
        .then(response => {
          this.errors = {}
          const history = response.data.initial_location_history
          const packing = this.applyCreatedPackingResponse(response.data)
          this.artwork.artwork_packings.push(packing)
          this.$store.commit('ADD_PACKING', packing)
          this.$emit(
            'showSnackbar',
            history && history.saved
              ? 'Packing and its initial location history were confirmed.'
              : 'Packing was confirmed without an initial location.',
            'green'
          )
        })
        .catch(error => {
          this.errors = error.response.data
        })
      // console.log(this.packing)
      // this.all_packings.push(this.packing)
      this.showUpload = !this.showUpload
      this.dialog = false
      this.resetPacking()
    },
    save() {
      serverBus.$emit('showSnackbar', 'Saving Packing', 'black')
      // this.$emit('showSnackbar', 'Saving Packing.', 'black')
      this.saving = true
      this.packing.artwork_id = this.artwork.id
      // this.packing.id = this.findMinMax(this.all_packings)+1
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = []
      }
      // this.artwork.artwork_packings.push(this.packing)
      if (this.editing) {
        let url = `${this.$globals.apiserver}/artwork_packings/${this.packing.id}.json`
        axios
          .put(url, {
            artwork_packing: this.packingUpdateAttributes()
          })
          .then(response => {
            this.resetPacking()
            this.saving = false
            this.editing = false
            serverBus.$emit('showSnackbar', 'Packing Saved', 'green')
            // this.$emit('showSnackbar', 'Packing Saved.', 'green')
            this.$emit('getArtwork')
            this.errors = {}
            this.artwork.artwork_packings = [
              ...this.artwork.artwork_packings.map(item =>
                item.id !== response.data.id
                  ? item
                  : { ...item, ...response.data }
              )
            ]
            this.close()
            this.$store.commit('SAVE_PACKING', response.data)
          })
          .catch(error => {
            this.saving = false
            this.save_error = true
            this.errors = error.response && error.response.data
              ? error.response.data
              : { base: ['Packing update was not confirmed by the server.'] }
            serverBus.$emit('showSnackbar', 'Packing was not saved.', 'red')
          })
      } else {
        this.packing.created_by = this.c_user.id
        axios
          .post(`${this.$globals.apiserver}/artwork_packings.json`, {
            artwork_packing: this.packing
          })
          .then(response => {
            const packing = this.applyCreatedPackingResponse(response.data)
            const history = response.data.initial_location_history
            serverBus.$emit(
              'showSnackbar',
              history && history.saved
                ? 'Packing and its initial location history were confirmed.'
                : 'Packing was confirmed without an initial location.',
              'green'
            )
            this.$emit('getArtwork')
            this.resetPacking()
            this.saving = false
            this.close()
            // this.editing = false
            this.errors = {}
            this.artwork.artwork_packings.push(packing)
            this.$store.commit('ADD_PACKING', packing)
          })
          .catch(error => {
            this.saving = false
            serverBus.$emit('showSnackbar', 'Error creating Packing.', 'red')
            this.errors = error.response && error.response.data
              ? error.response.data
              : { base: ['Packing creation was not confirmed by the server.'] }
          })
      }
    },
    applyCreatedPackingResponse(responseData) {
      const packing = { ...responseData }
      const history = packing.initial_location_history
      delete packing.initial_location_history
      delete packing.status

      if (history && history.saved) this.$store.commit('ADD_LOG', history)
      return packing
    },
    resetPacking() {
      this.packing = {
        packing: '',
        height: '',
        width: '',
        lenght: '',
        weight: '',
        created_by: '',
        contents: '',
        note: '',
        visa_status: 0,
        colli: '',
        artwork_location_id: '',
        location_id: ''
      }
    },
    update_multiple() {
      this.updated_packing.artwork_id = this.artwork.id
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = []
      }
      axios
        .get(
          `${this.$globals.apiserver}/artwork_packings/update_multiple.json`,
          {
            updated_packing: this.updated_packing,
            selected: this.selected
          }
        )
        .then(response => {
          this.errors = {}
          this.artwork.artwork_packings = []
          this.artwork.artwork_packings.push(response.data)
          // this.$store.commit('REPLACE_PACKING', response.data)
        })
        .catch(error => {
          this.errors = error.response.data
        })
      this.dialog2 = !this.dialog2
      // this.dialog = false
      this.updated_packing = {
        packing: '',
        height: '',
        width: '',
        length: '',
        weigth: '',
        contents: '',
        note: '',
        visa_status: 0
      }
    }
    // NEPOUZIVANE
    // findMinMax(arr) {
    //   let max = arr[0].id
    //   for (let i = 1, len=arr.length; i < len; i++) {
    //     let v = arr[i].id
    //     max = (v > max) ? v : max
    //   }
    //   return max
    // }
  },
  components: { ExcelPackings }
}
</script>

<style scoped>
/* .card {
  min-width: 250px;
} */
th {
  color: red;
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/artworks/Packings.vue